import classes from '../styles.module.scss'

export default function CheckboxIcon() {
  return (
    <svg
      className={classes.checkboxIcon}
      width='17px'
      height='17px'
      viewBox='0 0 36 36'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M31.4186 0.746094H4.58529C2.45779 0.746094 0.751953 2.47109 0.751953 4.57943V31.4128C0.751953 33.5211 2.45779 35.2461 4.58529 35.2461H31.4186C33.5461 35.2461 35.252 33.5211 35.252 31.4128V4.57943C35.252 2.47109 33.5461 0.746094 31.4186 0.746094ZM14.1681 27.5807L4.58472 17.9974L7.28722 15.2949L14.1681 22.1565L28.7156 7.60903L31.4181 10.3307L14.1681 27.5807Z'
        fill='url(#paint0_linear_28953_359)'
      />
      <defs>
        <linearGradient
          id='paint0_linear_28953_359'
          x1='35.2519'
          y1='0.746095'
          x2='29.9882'
          y2='39.2436'
          gradientUnits='userSpaceOnUse'
        >
          <stop stop-color='#FE139C' />
          <stop offset='1' stop-color='#C71CB8' />
        </linearGradient>
      </defs>
    </svg>
  )
}
